<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value=0 disabled) {{ $t("message.select_option") }}
    option(v-for="index in totalRow" :key="index") {{ index }}
</template>

<script>
import config from "@/config";

export default {
  props: {
    operatorID: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    bType: {
      type: String
    },
    viewType: {
      type: Number,
      default: null
    },
    position: {
      type: String,
      default: null
    }
  },
  data: () => ({
    options: [],
    totalRow: 0,
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted: function() {
    this.getCMSCount();
  },
  methods: {
    getCMSCount: function() {
      let url = "";

      if (this.bType == "announcement")
        url = config.cmsAnnouncementBannerCountUrl();
      else if (this.bType == "promotion")
        url = config.cmsPromotionBannerCountUrl();
      else if (this.bType == "slide")
        url = config.cmsSlideBannerCountUrl();
      else if (this.bType == "vip")
        url = config.vipCountUrl();
      else if (this.bType == "leaderboard")
        url = config.cmsLeaderboardBannerCountUrl();
      else if (this.bType == "referral")
        url = config.cmsReferralBannerCountUrl();
      else if (this.bType == "news")
        url = config.cmsNewsCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      if(['promotion','announcement','slide','leaderboard','referral'].includes(this.bType)) {
        json.view_type = this.viewType
      }

      if(['leaderboard','referral'].includes(this.bType)) {
        json.position = this.position
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.totalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows + 1 : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
